import { useQueryClient } from '@tanstack/react-query';

import { getUnitsQueryOptions } from '~/data/unit';

import { log } from '~/utils';
import { setCachedUnits } from '~/utils/unitUtils';

/**
 * Custom hook for loading units data.
 *
 * This hook provides functionality to preload units data using TanStack Query
 * to ensure units are cached and available throughout the application.
 *
 * @returns {Object} An object containing the loadUnits function.
 */
export const useLoadUnits = () => {
  const queryClient = useQueryClient();

  /**
   * Loads units data and caches it.
   *
   * This function fetches units data with German language as default
   * and caches it for later use throughout the application.
   */
  async function loadUnits() {
    try {
      const data = await queryClient.fetchQuery(
        getUnitsQueryOptions({
          queryParameters: {
            language: 'DE',
          },
        }),
      );

      setCachedUnits(data?.units || undefined);
    } catch (error) {
      log.error({
        message: 'Failed to load units data',
        error,
      });
    }
  }

  return {
    loadUnits,
  };
};
